import React from 'react';

const nest = (...Components) => (props) =>
  Components.reduceRight(
    (children, Component) => <Component {...props}>{children}</Component>,
    null
  );

export default nest;
